import React from "react";
import { motion } from "framer-motion";
import "../assets/css/Pricing.css";

const pricingTiers = [
  {
    name: "Starter",
    price: "£0",
    description: "Perfect for individuals starting with social media analytics.",
    features: [
      "Basic Insights",
      "Content Drill Down",
      "Essential Engagement Metrics",
      "Multi-platform Integration",
      "2 Social Profiles",
      "2 Profile Swaps per month",
    ],
    cta: "Start Your Free Trial"
  },
  {
    name: "Basic",
    price: "£19.99",
    description: "Ideal for growing brands enhancing their strategy.",
    features: [
      "Everything in Starter Plan",
      "Limited Competitor Tracking",
      "Download and Share Reports",
      "Competitor Analysis",
      "20 Social Profiles",
      "10 Profile Swaps per month",
    ],
    cta: "Start Your Free Trial"
  },
  {
    name: "Pro",
    price: "£29.99",
    description: "For established businesses managing multiple accounts.",
    features: [
      "Everything in Basic Plan",
      "Sentiment Analysis",
      "Comprehensive Insights",
      "Reach and Impressions",
      "Comments and Word Cloud",
      "Social Studio",
      "30 Social Profiles",
      "15 Profile Swaps per month",
      "5 Snapshots",
    ],
    cta: "Start Your Free Trial",
    popular: true // Highlight this tier as "Most Popular"
  },
  {
    name: "Ultra",
    price: "£39.99",
    description: "All-in-one solution, purpose-built for teams and creators with advanced needs.",
    features: [
      "Everything in Pro Plan",
      "AI-powered Insights",
      "Snapshot Scheduling",
      "Dedicated Account Management",
      "Content Optimisation",
      "Extended History Data",
      "40 Social Profiles",
      "20 Profile Swaps per month",
      "10 Snapshots",
    ],
    cta: "Start Your Free Trial"
  }
];

const Pricing = () => {
  const appFrontendUrl = process.env.REACT_APP_URL;
  return (
    <section className="pricing-section" id="pricing">
      <div className="container pricing-outer-card">
        <div className="text-center mb-5">
          <h2 className="section-title">Choose Your Plan</h2>
          <p className="section-subtitle">Flexible pricing for businesses of all sizes</p>
        </div>

        <div className="pricing-grid single-row">
          {pricingTiers.map((tier, index) => (
            <motion.div
              key={index}
              className={`pricing-card ${tier.popular ? "popular" : ""}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              {tier.popular && <div className="popular-badge">Most Popular</div>}
              <h3 className="pricing-title">{tier.name}</h3>
              <p className="pricing-price">{tier.price}/month</p>
              <p className="pricing-description">{tier.description}</p>

              <ul className="pricing-features">
                {tier.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>

              <button
                className="pricing-cta"
                onClick={() => {
                  if (tier.cta === "Start Your Free Trial") {
                    window.location.href = `${appFrontendUrl}/auth/register`;
                  } else if (tier.cta === "Request a demo") {
                    window.location.href = `${appFrontendUrl}/auth/demo`;
                  }
                }}
              >
                {tier.cta}
              </button>

            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
